export function BranchStockTransferCtrl ($scope, companies, inheritorApi) {
  $scope.companies = companies;

  inheritorApi.inheritCtrl('BranchStockTransferLiteCtrl', $scope);
}
